import CurrencyLogo from 'components/Logo/CurrencyLogo'
import Row from 'components/Row'
import { ArrowRight } from 'react-feather'
import { InterfaceTrade } from 'state/routing/types'
import { useTheme } from 'styled-components/macro'
import { ThemedText } from 'theme'
import { formatCurrencyAmount } from 'utils/formatCurrencyAmount'

export function TradeSummary({ trade }: { trade: InterfaceTrade }) {
  const theme = useTheme()
  return (
    <Row gap="sm" justify="center" align="center">
      <CurrencyLogo currency={trade.inputAmount.currency} size="22px" />
      <ThemedText.LabelSmall color="textPrimary" fontSize="15px">
        {formatCurrencyAmount(trade.inputAmount, 8)} {trade.inputAmount.currency.symbol}
      </ThemedText.LabelSmall>
      <ArrowRight color={theme.textPrimary} size="15px" />
      <CurrencyLogo currency={trade.outputAmount.currency} size="22px" />
      <ThemedText.LabelSmall color="textPrimary" fontSize="15px">
        {formatCurrencyAmount(trade.outputAmount, 8)} {trade.outputAmount.currency.symbol}
      </ThemedText.LabelSmall>
    </Row>
  )
}
